module.exports = __webpack_public_path__ + "img/home-solution-shuzi.dc645433.png";